<template>
    <div>
        <el-dialog :visible.sync="visible" width="600px" title="回复评论">
            <div style="display: flex">
                <img v-if="row.user && row.user.avatar" class="avatar" :src="ossUrl + row.user.avatar" alt="" />
                <div v-else class="avatar-none"></div>
                <div class="info">
                    <div class="top">
                        <div class="name">{{ row.user_nick_name }}</div>
                        <div>
                            <div class="product">商品：{{ row.goods_name }}</div>
                            <div class="comment">{{ row.content }}</div>
                        </div>
                    </div>
                    <div class="pics">
                        <div v-for="pic in row.images" :key="pic.id">
                            <video controls v-if="isVideo(pic.url)" :src="formatter(pic.url)"></video>
                            <img v-else @click="handlePreview(pic.url)" :src="formatter(pic.url)" alt="" />
                        </div>
                    </div>
                    <div class="time">{{ row.create_time }}</div>
                </div>
            </div>
            <el-form style="margin-top: 20px" :model="form" ref="form" :rules="rules">
                <el-form-item label="" prop="content">
                    <el-input :rows="5" placeholder="回复该评论" type="textarea" v-model="form.content"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="handleConfirm">确定</el-button>
            </div>
        </el-dialog>
        <PicPreviewer ref="preview"></PicPreviewer>
    </div>
</template>

<script>
import { ossUrl } from "@/configs/oss";
import { reply } from "@/api/product/comment";
import PicPreviewer from "@/components/PicPreviewer";
export default {
    components: { PicPreviewer },
    data() {
        return {
            ossUrl,
            visible: false,
            row: {},
            form: {},
            rules: {
                content: [{ required: true, message: "请输入回复内容" }],
            },
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            this.row = row;
        },
        formatter(url) {
            if (url.indexOf("http") > -1) {
                return url;
            }
            return this.ossUrl + url;
        },
        handlePreview(url) {
            this.$refs.preview.open(url);
        },
        isVideo(url) {
            let res = false;
            [
                ".mp4",
                ".MP4",
                ".avi",
                ".AVI",
                ".mov",
                ".MOV",
                ".wmv",
                ".WMV",
                ".mpg",
                ".MPG",
                ".rm",
                ".RM",
                ".rmvb",
                ".RMVB",
                ".flv",
                ".FLV",
                ".mkv",
                ".MKV",
                ".f4v",
                ".F4V",
                ".mpeg",
                ".MPEG",
            ].forEach((x) => {
                if (url.indexOf(x) > -1) {
                    res = true;
                }
            });
            return res;
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                reply({ uuid: this.row.uuid, content: this.form.content }).then(({ code, error }) => {
                    if (code === 200) {
                        this.$message.success("回复成功");
                        this.visible = false;
                        this.$emit("update");
                    } else {
                        this.$message.error(error.message);
                    }
                });
            });
        },
    },
};
</script>

<style lang="less" scoped>
.avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 20px;
    margin-top: 20px;
}
.avatar-none {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    background: #eee;
    margin-right: 20px;
    margin-top: 20px;
}
.top {
    display: flex;
    .name {
        min-width: 100px;
        margin-right: 10px;
    }
    .product {
        color: #999;
        margin-bottom: 20px;
    }
}
.time {
    color: #999;
    margin-top: 20px;
}
.pics {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    flex-wrap: wrap;
    img {
        height: 90px;
        max-width: 100%;
    }
    video {
        height: 300px;
        max-width: 100%;
    }
}
</style>
